export default __webpack_public_path__ + "static/media/pendingBackground.1b8b5cb7.png";